import React, { Component } from 'react';
import Notifications from './Notifications';
import PostList from '../posts/PostList';
import ProfilePanel from '../profile/ProfilePanel';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import CreatePost from '../posts/CreatePost';

import * as ROUTES from '../../constants/routes';

class Dashboard extends Component {
    render() {
        const { posts, auth, notifications, profile, users } = this.props;
        

        if(!auth.uid) return <Redirect to={ROUTES.SIGNIN} />

        const pageCode = auth.isLoaded ? (
            <div className="container main-container">
                <div className="row">
                    <div className="col-lg-3 col-sm-12">
                        <ProfilePanel  profile={profile}/>
                    </div>
                    <div className="col-lg-6 col-sm-12">
                        <CreatePost auth={auth} profile={profile}  />
                        <PostList posts={posts} profile={profile} users={users} auth={auth} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <Notifications notifications={notifications} auth={auth} />
                    </div>
                </div>
            </div>) : null;
        
        return (
            pageCode
        )
    }
}

const mapStateToProps = (state) => {
    console.log(state);
    return {
        posts: state.firestore.ordered.posts,
        auth: state.firebase.auth,
        profile: state.firebase.profile,
        notifications: state.firestore.ordered.notifications,
        users: state.firestore.ordered.users
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect([
        { collection: 'posts', orderBy: ['createdAt','desc'] },
        { collection: 'notifications', limit: 15, orderBy: ['time','desc'] },
        { collection: 'users' }
    ])
)(Dashboard);
